import {
  JOB_RECRUIT_EDIT_FETCHING,
  JOB_RECRUIT_EDIT_FAILED,
  JOB_RECRUIT_EDIT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOB_RECRUIT_EDIT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOB_RECRUIT_EDIT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOB_RECRUIT_EDIT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
